import styled from 'styled-components';

export const Description = styled.h2`
  font-size: 16px;
  font-weight: 400;
  color: ${(props) => props.theme.colors.black};
  line-height: 120%;
  margin-bottom: 24px;
`;

export const Link = styled.p<{ top?: number; error?: boolean }>`
  color: ${(props) =>
    props.error ? props.theme.colors.danger : props.theme.colors.primary};
  font-size: 16px;
  text-align: center;
  font-weight: bold;
  margin-top: ${(props) => (props.top ? `${props.top}px` : '20px')};
  cursor: pointer;
`;
